import Lottie from "lottie-react";
import logo from "./../../assets/lottie/logo.json";
import { useContext } from "react";
import { AppContext } from "../../context/AppProvider";

export const LottieAnimation = () => {
  const { state } = useContext(AppContext);
  return (
    <>
      {state.lottieAnimation && (
        <div
          className="fixed top-0 left-0 w-screen h-screen z-50"
          style={{ background: "rgba(0, 0, 0, 0.7)" }}
        >
          <Lottie
            animationData={logo}
            loop={true}
            className="w-screen h-screen absolute opacity-100"
            style={{ overflow: "hidden", top: "36%", height: "220px" }}
          />
        </div>
      )}
    </>
  );
};
